// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file api/core/svc_access.proto (package com.diagnocat.core, syntax proto3)
/* eslint-disable */

import { Empty, proto3 } from "@bufbuild/protobuf";
import { SharingInvitation } from "../../model/dto_sharing_pb.js";
import { Organization } from "../../model/dto_organization_pb.js";
import { OrganizationStaff, OrganizationStaffRoleType } from "../../model/dto_organization_staff_pb.js";
import { Patient } from "../../model/dto_patient_pb.js";
import { OrganizationJobPosition } from "../../model/dto_organization_job_position_pb.js";
import { PatientTask } from "../../model/dto_patient_task_pb.js";

/**
 * @generated from enum com.diagnocat.core.SharedByMeStreamSortBy
 */
export const SharedByMeStreamSortBy = proto3.makeEnum(
  "com.diagnocat.core.SharedByMeStreamSortBy",
  [
    {no: 0, name: "SharedByMeStreamSortByPatientFirstName"},
    {no: 1, name: "SharedByMeStreamSortByPatientLastName"},
    {no: 2, name: "SharedByMeStreamSortBySenderFirstName"},
    {no: 3, name: "SharedByMeStreamSortBySenderLastName"},
    {no: 4, name: "SharedByMeStreamSortByRecipientEmail"},
    {no: 5, name: "SharedByMeStreamSortBySharingDate"},
    {no: 6, name: "SharedByMeStreamSortByStatus"},
  ],
);

/**
 * @generated from enum com.diagnocat.core.SharedWithMeStreamSortBy
 */
export const SharedWithMeStreamSortBy = proto3.makeEnum(
  "com.diagnocat.core.SharedWithMeStreamSortBy",
  [
    {no: 0, name: "SharedWithMeStreamSortByClinicName"},
    {no: 1, name: "SharedWithMeStreamSortByPatientFirstName"},
    {no: 2, name: "SharedWithMeStreamSortByPatientLastName"},
    {no: 3, name: "SharedWithMeStreamSortBySenderFirstName"},
    {no: 4, name: "SharedWithMeStreamSortBySenderLastName"},
    {no: 5, name: "SharedWithMeStreamSortBySenderEmail"},
    {no: 6, name: "SharedWithMeStreamSortBySharingDate"},
    {no: 7, name: "SharedWithMeStreamSortByStatus"},
  ],
);

/**
 * @generated from message com.diagnocat.core.SharedByMeStreamReq
 */
export const SharedByMeStreamReq = proto3.makeMessageType(
  "com.diagnocat.core.SharedByMeStreamReq",
  () => [
    { no: 2, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "SearchString", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "Sort", kind: "message", T: SharedByMeStreamSort, repeated: true },
    { no: 100, name: "StartFromSharingID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 101, name: "Limit", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.SharedByMeStreamSort
 */
export const SharedByMeStreamSort = proto3.makeMessageType(
  "com.diagnocat.core.SharedByMeStreamSort",
  () => [
    { no: 1, name: "By", kind: "enum", T: proto3.getEnumType(SharedByMeStreamSortBy) },
    { no: 2, name: "Ascending", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.SharedWithMeStreamReq
 */
export const SharedWithMeStreamReq = proto3.makeMessageType(
  "com.diagnocat.core.SharedWithMeStreamReq",
  () => [
    { no: 2, name: "SearchString", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "Sort", kind: "message", T: SharedWithMeStreamSort, repeated: true },
    { no: 100, name: "StartFromSharingID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 101, name: "Limit", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.SharedWithMeStreamSort
 */
export const SharedWithMeStreamSort = proto3.makeMessageType(
  "com.diagnocat.core.SharedWithMeStreamSort",
  () => [
    { no: 1, name: "By", kind: "enum", T: proto3.getEnumType(SharedWithMeStreamSortBy) },
    { no: 2, name: "Ascending", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.SharingListStreamResp
 */
export const SharingListStreamResp = proto3.makeMessageType(
  "com.diagnocat.core.SharingListStreamResp",
  () => [
    { no: 10, name: "InitialSharesList", kind: "message", T: SharingListStreamResp_InitialShares, oneof: "Update" },
    { no: 11, name: "UpdatedSharing", kind: "message", T: SharingInvitation, oneof: "Update" },
    { no: 21, name: "TotalOrganizationPatientCount", kind: "scalar", T: 13 /* ScalarType.UINT32 */, oneof: "Update" },
    { no: 22, name: "SharedWithMeCount", kind: "scalar", T: 13 /* ScalarType.UINT32 */, oneof: "Update" },
    { no: 23, name: "SharedByMeCount", kind: "scalar", T: 13 /* ScalarType.UINT32 */, oneof: "Update" },
    { no: 101, name: "Ping", kind: "message", T: Empty, oneof: "Update" },
  ],
);

/**
 * @generated from message com.diagnocat.core.SharingListStreamResp.InitialShares
 */
export const SharingListStreamResp_InitialShares = proto3.makeMessageType(
  "com.diagnocat.core.SharingListStreamResp.InitialShares",
  () => [
    { no: 1, name: "Shares", kind: "message", T: SharingInvitation, repeated: true },
  ],
  {localName: "SharingListStreamResp_InitialShares"},
);

/**
 * @generated from message com.diagnocat.core.GetInvitationByTokenReq
 */
export const GetInvitationByTokenReq = proto3.makeMessageType(
  "com.diagnocat.core.GetInvitationByTokenReq",
  () => [
    { no: 1, name: "Token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.GetInvitationByTokenResp
 */
export const GetInvitationByTokenResp = proto3.makeMessageType(
  "com.diagnocat.core.GetInvitationByTokenResp",
  () => [
    { no: 1, name: "Organization", kind: "message", T: Organization },
    { no: 11, name: "Sharing", kind: "message", T: SharingInvitation, oneof: "Result" },
    { no: 12, name: "OrganizationStaff", kind: "message", T: OrganizationStaff, oneof: "Result" },
  ],
);

/**
 * @generated from message com.diagnocat.core.SharePatientReq
 */
export const SharePatientReq = proto3.makeMessageType(
  "com.diagnocat.core.SharePatientReq",
  () => [
    { no: 1, name: "RecipientEmail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "PatientID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "AutoAccept", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "Comment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 22, name: "SendNotificationEmail", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 23, name: "ToReturnInviteToken", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.SharePatientResp
 */
export const SharePatientResp = proto3.makeMessageType(
  "com.diagnocat.core.SharePatientResp",
  () => [
    { no: 1, name: "Sharing", kind: "message", T: SharingInvitation },
    { no: 2, name: "Patient", kind: "message", T: Patient, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.core.InviteStaffReq
 */
export const InviteStaffReq = proto3.makeMessageType(
  "com.diagnocat.core.InviteStaffReq",
  () => [
    { no: 1, name: "RecipientEmail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "FirstName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "LastName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "Role", kind: "enum", T: proto3.getEnumType(OrganizationStaffRoleType) },
    { no: 15, name: "JobPositions", kind: "enum", T: proto3.getEnumType(OrganizationJobPosition), repeated: true },
    { no: 16, name: "ExternalID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 22, name: "SendNotificationEmail", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 23, name: "ToReturnInviteToken", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.InviteStaffResp
 */
export const InviteStaffResp = proto3.makeMessageType(
  "com.diagnocat.core.InviteStaffResp",
  () => [
    { no: 1, name: "OrganizationStaff", kind: "message", T: OrganizationStaff },
    { no: 2, name: "CancelledShares", kind: "message", T: SharingInvitation, repeated: true },
    { no: 3, name: "Patients", kind: "message", T: Patient, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.core.AcceptSharingReq
 */
export const AcceptSharingReq = proto3.makeMessageType(
  "com.diagnocat.core.AcceptSharingReq",
  () => [
    { no: 1, name: "SharingID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Secret", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.AcceptSharingResp
 */
export const AcceptSharingResp = proto3.makeMessageType(
  "com.diagnocat.core.AcceptSharingResp",
  () => [
    { no: 1, name: "Sharing", kind: "message", T: SharingInvitation },
    { no: 2, name: "Patient", kind: "message", T: Patient },
  ],
);

/**
 * @generated from message com.diagnocat.core.CancelSharingInvitationReq
 */
export const CancelSharingInvitationReq = proto3.makeMessageType(
  "com.diagnocat.core.CancelSharingInvitationReq",
  () => [
    { no: 1, name: "SharingID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.CancelSharingInvitationResp
 */
export const CancelSharingInvitationResp = proto3.makeMessageType(
  "com.diagnocat.core.CancelSharingInvitationResp",
  () => [
    { no: 1, name: "Sharing", kind: "message", T: SharingInvitation },
  ],
);

/**
 * @generated from message com.diagnocat.core.RevokeSharingReq
 */
export const RevokeSharingReq = proto3.makeMessageType(
  "com.diagnocat.core.RevokeSharingReq",
  () => [
    { no: 1, name: "UserID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "PatientID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.RevokeSharingResp
 */
export const RevokeSharingResp = proto3.makeMessageType(
  "com.diagnocat.core.RevokeSharingResp",
  () => [
    { no: 1, name: "Patient", kind: "message", T: Patient },
    { no: 2, name: "Sharing", kind: "message", T: SharingInvitation },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetPatientTeamMembersReq
 */
export const SetPatientTeamMembersReq = proto3.makeMessageType(
  "com.diagnocat.core.SetPatientTeamMembersReq",
  () => [
    { no: 1, name: "PatientID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "StaffIDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetPatientTeamMembersResp
 */
export const SetPatientTeamMembersResp = proto3.makeMessageType(
  "com.diagnocat.core.SetPatientTeamMembersResp",
  () => [
    { no: 1, name: "Patient", kind: "message", T: Patient },
    { no: 2, name: "Tasks", kind: "message", T: PatientTask, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetOrganizationStaffRoleReq
 */
export const SetOrganizationStaffRoleReq = proto3.makeMessageType(
  "com.diagnocat.core.SetOrganizationStaffRoleReq",
  () => [
    { no: 1, name: "StaffID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Role", kind: "enum", T: proto3.getEnumType(OrganizationStaffRoleType) },
  ],
);

/**
 * @generated from message com.diagnocat.core.SetOrganizationStaffRoleResp
 */
export const SetOrganizationStaffRoleResp = proto3.makeMessageType(
  "com.diagnocat.core.SetOrganizationStaffRoleResp",
  () => [
    { no: 1, name: "OrganizationStaff", kind: "message", T: OrganizationStaff },
  ],
);

/**
 * @generated from message com.diagnocat.core.RemoveOrganizationStaffReq
 */
export const RemoveOrganizationStaffReq = proto3.makeMessageType(
  "com.diagnocat.core.RemoveOrganizationStaffReq",
  () => [
    { no: 1, name: "StaffID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.RemoveOrganizationStaffResp
 */
export const RemoveOrganizationStaffResp = proto3.makeMessageType(
  "com.diagnocat.core.RemoveOrganizationStaffResp",
  () => [
    { no: 1, name: "OrganizationStaff", kind: "message", T: OrganizationStaff },
  ],
);

